<template lang="html">
  <img src="@/assets/logo.png" alt="SThree" width="250" />
  <h2 class="title">
    I give consent to receive marketing material from SThree via email. I
    understand that I can unsubscribe at any time by using the unsubscribe
    option in the communication or by contacting SThree <br />
    Ik geef toestemming voor het ontvangen van marketingmateriaal van SThree via
    e-mail. Ik begrijp dat ik me op elk moment kan afmelden door gebruik te
    maken van de afmeldoptie in de email of door contact op te nemen met SThree.
  </h2>
  <div class="d-grid gap-2">
    <button
      v-for="answer in answers"
      v-bind:key="answer"
      type="button"
      class="btn btn-lg text-light bg-field"
      :class="[answerChecked(answer) ? 'btn-primary' : 'btn-secondary']"
      @click="addRemoveAnswer(answer)"
    >
      <i class="bi bi-square" v-if="!answerChecked(answer)"></i>
      <i class="bi bi-check-square" v-if="answerChecked(answer)"></i>
      {{ answer }}
    </button>
    <button
      type="button"
      class="btn btn-primary text-light btn-lg"
      @click="saveAndGetQrCode()"
    >
      <span v-if="checkedAnswers.length < 1">Nee</span>
      <span v-if="checkedAnswers.length > 0">Volgende</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "questionFourScreen",
  data: () => ({
    answers: ["Ja"],
    checkedAnswers: [],
  }),
  computed: {},
  methods: {
    addRemoveAnswer(answer) {
      if (this.checkedAnswers.indexOf(answer) !== -1) {
        this.checkedAnswers.splice(this.checkedAnswers.indexOf(answer), 1);
      } else {
        this.checkedAnswers.push(answer);
      }
    },
    answerChecked(answer) {
      if (this.checkedAnswers.indexOf(answer) !== -1) {
        return true;
      }
      return false;
    },
    saveAndGetQrCode() {
      this.$store.commit("setQuestionFour", this.checkedAnswers);
    },
  },
};
</script>

<style lang="css" scoped>
h1 {
  font-size: 40px;
  color: #000;
}
.bg-field {
  color: #fdf7ea !important;
}
</style>
